<template>
    <div class="webhook-config">
        <div class="config-field">
            <label>Webhook URL</label>
            <div class="input-with-variables">
                <a-input
                    v-model="localConfig.url"
                    :placeholder="'https://example.com/webhook?taskId={{task._id}}'"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    Değişkenler
                </a-button>
            </div>
            <small>
                URL'de dinamik değişkenler kullanabilirsiniz. 
                <span v-pre>{{'{{task._id}}'}}</span>, 
                <span v-pre>{{'{{task.title}}'}}</span>, 
                <span v-pre>{{'{{task.owner.name}}'}}</span>, vb.
            </small>
        </div>

        <div class="config-field">
            <label>HTTP Method</label>
            <a-select
                v-model="localConfig.method"
                style="width: 100%;"
                @change="emitChange"
            >
                <a-select-option value="GET">GET</a-select-option>
                <a-select-option value="POST">POST</a-select-option>
                <a-select-option value="PUT">PUT</a-select-option>
            </a-select>
        </div>

        <div v-if="localConfig.method !== 'GET'" class="config-field">
            <label>Body Tipi</label>
            <a-radio-group v-model="localConfig.bodyType" @change="emitChange" button-style="solid">
                <a-radio-button value="full_task">Tüm Görev Datası</a-radio-button>
                <a-radio-button value="custom">Özel JSON</a-radio-button>
            </a-radio-group>
        </div>

        <div v-if="localConfig.method !== 'GET' && localConfig.bodyType === 'custom'" class="config-field">
            <label>Özel JSON Body</label>
            <div class="input-with-variables">
                <a-textarea
                    v-model="localConfig.customBody"
                    :placeholder="'{\"taskId\": \"{{task._id}}\", \"title\": \"{{task.title}}\"}'"
                    :rows="6"
                    @change="emitChange"
                />
                <a-button type="link" size="small" @click="showVariablesPicker = true">
                    <i class="material-icons">code</i>
                    Değişkenler
                </a-button>
            </div>
            <small>
                Geçerli bir JSON formatında girin. Dinamik değişkenler kullanabilirsiniz. 
                Örn: <span v-pre>{{'{{task._id}}'}}</span>, <span v-pre>{{'{{task.title}}'}}</span>
            </small>
        </div>

        <div class="config-field">
            <label>Headers (opsiyonel)</label>
            <div
                v-for="(value, key, index) in localConfig.headers"
                :key="`header-${index}`"
                class="header-row"
            >
                <a-input
                    :value="key"
                    placeholder="Header adı"
                    style="flex: 1;"
                    @change="e => updateHeaderKey(key, e.target.value)"
                />
                <a-input
                    v-model="localConfig.headers[key]"
                    placeholder="Header değeri"
                    style="flex: 1;"
                    @change="emitChange"
                />
                <a-button type="text" size="small" danger @click="removeHeader(key)">
                    <i class="material-icons">delete</i>
                </a-button>
            </div>

            <a-button type="dashed" block @click="addHeader">
                <i class="material-icons">add</i>
                Header Ekle
            </a-button>
        </div>

        <DynamicVariablesPicker
            v-if="showVariablesPicker"
            :visible="showVariablesPicker"
            @close="showVariablesPicker = false"
            @select="insertVariable"
        />
    </div>
</template>

<script>
import DynamicVariablesPicker from "./DynamicVariablesPicker.vue";

export default {
    name: "WebhookConfig",
    components: {
        DynamicVariablesPicker
    },
    props: {
        value: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            localConfig: {
                url: '',
                method: 'POST',
                bodyType: 'full_task',
                customBody: '',
                headers: {}
            },
            showVariablesPicker: false
        };
    },
    watch: {
        value: {
            handler(newVal) {
                if (newVal) {
                    this.localConfig = JSON.parse(JSON.stringify(newVal));
                    if (!this.localConfig.headers) {
                        this.localConfig.headers = {};
                    }
                }
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        emitChange() {
            this.$emit("input", JSON.parse(JSON.stringify(this.localConfig)));
        },

        addHeader() {
            const newKey = `Header-${Object.keys(this.localConfig.headers).length + 1}`;
            this.$set(this.localConfig.headers, newKey, '');
            this.emitChange();
        },

        removeHeader(key) {
            this.$delete(this.localConfig.headers, key);
            this.emitChange();
        },

        updateHeaderKey(oldKey, newKey) {
            if (oldKey === newKey) return;
            const value = this.localConfig.headers[oldKey];
            this.$delete(this.localConfig.headers, oldKey);
            this.$set(this.localConfig.headers, newKey, value);
            this.emitChange();
        },

        insertVariable(variable) {
            if (this.localConfig.bodyType === 'custom') {
                this.localConfig.customBody += ` {{${variable}}}`;
            } else {
                this.localConfig.url += `{{${variable}}}`;
            }
            this.emitChange();
        }
    }
};
</script>

<style lang="scss" scoped>
.webhook-config {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .config-field {
        label {
            display: block;
            font-weight: 600;
            margin-bottom: 8px;
            color: #1a1a1a;
        }

        small {
            display: block;
            color: #999;
            font-size: 12px;
            margin-top: 6px;
        }

        .input-with-variables {
            display: flex;
            gap: 8px;
            align-items: flex-start;

            .ant-input,
            .ant-textarea {
                flex: 1;
            }
        }

        .header-row {
            display: flex;
            gap: 8px;
            margin-bottom: 8px;
        }
    }
}
</style>
